import { DiscordIcon, FacebookIcon } from '@blade/ui-kit'
import {
  WebsiteIcon,
  TiktokSocialIcon,
  YoutubeSocialIcon,
  LinkedinSocialIcon,
  GithubSocialIcon,
  RedditSocialIcon,
  MediumSocialIcon,
  SubstackSocialIcon,
  TwitchSocialIcon,
  PinterestSocialIcon,
  ThreadsSocialIcon,
  WhatsappSocialIcon,
  WikiPediaSocialIcon,
  TelegramSocialIcon,
  InstagramSocialIcon,
  XSocialIcon,
  BlueSkySocialIcon,
} from '@root/shared/ui-kit'

import type { KnownSocialPlatform } from '@root/entities/socials'

export const WebsiteUrlSocialIcon = ({
  knownPlatform,
  size = 14,
}: {
  knownPlatform: KnownSocialPlatform.KnownSocialPlatform
  size?: number
}) => {
  const Icon = platformIcons[knownPlatform._tag]
  return <Icon size={size} />
}

const platformIcons: Record<
  KnownSocialPlatform.KnownSocialPlatformTag,
  React.FC<{ size: number }>
> = {
  youtube: YoutubeSocialIcon,
  tiktok: TiktokSocialIcon,
  x: XSocialIcon,
  instagram: InstagramSocialIcon,
  facebook: FacebookIcon,
  discord: DiscordIcon,
  telegram: TelegramSocialIcon,
  linkedin: LinkedinSocialIcon,
  github: GithubSocialIcon,
  reddit: RedditSocialIcon,
  medium: MediumSocialIcon,
  substack: SubstackSocialIcon,
  twitch: TwitchSocialIcon,
  pinterest: PinterestSocialIcon,
  threads: ThreadsSocialIcon,
  whatsapp: WhatsappSocialIcon,
  wiki: WikiPediaSocialIcon,
  bluesky: BlueSkySocialIcon,
  website: WebsiteIcon,
}
